<template>
    <div>
        <!-- 列表视图 -->
        <template v-if="view == 'list'">
            <!-- 页面标题 -->
            <div class="page-header">
                <div class="line"></div>
                <div class="page-title">结算单</div>
            </div>

            <!-- 状态标签页 -->
            <div class="status-tabs">
                <el-radio-group v-model="activeStatus" size="small" class="status-radio-group" @change="handleStatusChange">
                    <el-radio-button label="0">待支付</el-radio-button>
                    <el-radio-button label="1">已支付</el-radio-button>
                </el-radio-group>
            </div>

            <!-- 结算单表格 -->
            <el-table :data="statementData" :border="true" style="width: 100%" class="statement-table">
                <!-- 结算单状态 -->
                <el-table-column prop="pay_status" label="结算单状态" width="120">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.pay_status)">
                            {{ scope.row.pay_status == 1 ? '已支付' : '待支付' }}
                        </span>
                    </template>
                </el-table-column>

                <!-- 结算单号 -->
                <el-table-column prop="order_sn" label="结算单号" min-width="200"></el-table-column>

                <!-- 账单金额 -->
                <el-table-column prop="payable_money" label="账单金额" width="140">
                    <template slot-scope="scope">
                        <span class="money">¥{{ scope.row.payable_money }}</span>
                    </template>
                </el-table-column>

                <!-- 账单周期 -->
                <el-table-column prop="settle_type_name" label="账单周期" width="140"></el-table-column>

                <!-- 账单生成时间 -->
                <el-table-column prop="create_time" label="账单生成时间" width="180"></el-table-column>

                <!-- 操作 -->
                <el-table-column label="操作" width="220">
                    <template slot-scope="scope">
                        <div class="action-buttons">
                            <el-button type="text" size="small" class="text-btn view-details"
                                @click="handleViewDetail(scope.row)">查看详情</el-button>
                            <el-button type="primary" size="small" class="pay-btn"
                                v-if="scope.row.pay_status != 1" @click="handlePay(scope.row)">立即支付</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页控件 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalOrders">
                </el-pagination>
            </div>
        </template>

        <!-- 详情视图 -->
        <template v-else>
            <!-- 页面标题 -->
            <div class="page-header">
                <div class="line"></div>
                <div class="page-title">结算单详情</div>
            </div>

            <!-- 结算单信息 -->
            <div class="detail-info">
                <div class="detail-info-title">结算单信息</div>
                <div class="info-row">
                    <span class="info-label">结算单号：</span>
                    <span class="info-value">{{ detailData.order_sn }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">账单金额：</span>
                    <span class="info-value money">¥{{ detailData.payable_money }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">账单周期：</span>
                    <span class="info-value">{{ detailData.settle_type_name }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">账单生成时间：</span>
                    <span class="info-value">{{ detailData.create_time }}</span>
                </div>
                <div class="info-row" v-if="detailData.pay_time">
                    <span class="info-label">账单支付时间：</span>
                    <span class="info-value">{{ detailData.pay_time }}</span>
                </div>
            </div>

            <!-- 采购单表格 -->
            <div class="section-title section-title-center">采购单</div>
            <el-table :data="purchaseList" :border="true" style="width: 100%" class="purchase-table">
                <el-table-column prop="order_sn" label="采购单号" min-width="180"></el-table-column>
                <el-table-column prop="status_name" label="订单状态" width="120"></el-table-column>
                <el-table-column prop="title" label="采购标题" min-width="200"></el-table-column>
                <el-table-column prop="settle_type_name" label="账单周期" width="120"></el-table-column>
                <el-table-column prop="total_amount" label="采购单金额" width="140">
                    <template slot-scope="scope">
                        <span class="money">¥{{ scope.row.total_amount }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" class="text-btn"
                            @click="handleViewPurchase(scope.row)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 底部操作 -->
            <div class="detail-footer" v-if="detailData.pay_status != 1">
                <el-button type="primary" size="medium" class="pay-btn" @click="handlePay(detailData)">立即支付</el-button>
            </div>

            <div class="detail-back">
                <el-button type="text" @click="backToList">返回列表</el-button>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'SettlementStatements',
    data() {
        return {
            view: 'list',
            activeStatus: '0',
            // 分页数据
            currentPage: 1,
            pageSize: 10,
            totalOrders: 0,
            statementData: [],
            // 详情数据
            detailData: {},
            purchaseList: []
        }
    },
    mounted() {
        this.getSettlementList();
    },
    methods: {
        handleStatusChange(value) {
            this.activeStatus = value;
            this.currentPage = 1;
            this.getSettlementList();
        },
        getStatusClass(status) {
            return status == 1 ? 'status-paid' : 'status-unpaid';
        },
        // 查看结算单详情
        handleViewDetail(row) {
            this.$api.getSettlementDetail({ aid: row.aid }).then(res => {
                this.detailData = res || {};
                this.purchaseList = res.purchase_list || [];
                this.view = 'detail';
            }).catch(err => {
                this.$message.error(err.message || err);
            });
        },
        // 查看采购单详情（跳转到我的采购-采购详情，传 aid）
        handleViewPurchase(row) {
            this.$parent.currentComponent = 'MyPurchases';
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    component: 'MyPurchases',
                    purchaseId: row.aid
                }
            });
        },
        // 立即支付
        handlePay(row) {
            console.log(row)
            this.$router.push({
                name: 'Payment',
                query: {
                    order_sn: row.order_sn,
                    is_from: 5, // 结算单来源
                },
                params: {
                    money: row.payable_money,
                    order_config_id: 19, // 结算付款
                },
            });
        },
        // 返回列表
        backToList() {
            this.view = 'list';
            this.detailData = {};
            this.purchaseList = [];
        },
        // 获取结算单列表
        getSettlementList() {
            this.$api.getSettlementList({
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                pay_status: this.activeStatus
            }).then(res => {
                this.statementData = res.data || [];
                this.totalOrders = res.total || 0;
            }).catch(err => {
                this.$message.error(err.message || err);
            })
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getSettlementList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getSettlementList();
        }
    }
}
</script>

<style scoped>
/* 页面标题 */
.page-header {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.page-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding-left: 10px;
    text-align: left;
}

.line {
    width: 3px;
    height: 18px;
    background-color: #286CED;
}

/* 状态标签页 */
.status-tabs {
    margin-bottom: 20px;
    overflow-x: auto;
}

.status-radio-group {
    display: flex;
    align-items: center;
    white-space: nowrap;
}

::v-deep .el-radio-button__original-radio:checked+.el-radio-button__inner {
    background-color: #286CED;
    border-color: #286CED;
}

/* 表格 */
.statement-table,
.purchase-table {
    border-radius: 8px;
    overflow: hidden;
}

.money {
    color: #ff4d4f;
    font-weight: 600;
}

.status-paid {
    color: #67c23a;
}

.status-unpaid {
    color: #f56c6c;
}

/* 操作按钮 */
.action-buttons {
    display: flex;
    gap: 8px;
    align-items: center;
}

.text-btn {
    font-size: 12px;
    color: #666;
    padding: 6px 12px;
    border: 1px solid #dcdcdc;
}

.pay-btn {
    font-size: 12px;
    padding: 6px 12px;
}

/* 分页 */
.pagination-container {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    text-align: center;
    margin-top: 20px;
}

/* 详情页 */
.detail-status {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 24px;
    text-align: center;
}

.detail-info {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 24px;
    margin-bottom: 30px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    text-align: left;
}

.detail-info-title {
    font-size: 16px;
    font-weight: 700;
    color: #333;
    margin-bottom: 20px;
}

.info-row {
    margin-bottom: 12px;
    font-size: 14px;
    line-height: 1.6;
    text-align: left;
}

.info-row:last-child {
    margin-bottom: 0;
}

.info-label {
    color: #666;
}

.info-value {
    color: #333;
    font-weight: 500;
}

.info-value.money {
    color: #ff4d4f;
    font-weight: 700;
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
}

.section-title-center {
    text-align: center;
}

.detail-footer {
    text-align: center;
    margin-top: 30px;
}

.detail-footer .pay-btn {
    padding: 10px 32px;
    font-size: 14px;
}

.detail-back {
    text-align: center;
    margin-top: 16px;
}

.detail-back .el-button--text {
    color: #286CED;
}

@media (max-width: 768px) {
    .action-buttons {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: center;
    }
}
</style>
